import {Inject, Injectable, NgZone} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DistributionsService {
    public visible = new BehaviorSubject(null);

    constructor(private ngZone: NgZone) {

    }

    show() {
        this.visible.next(true);
    }

    hide() {
        this.visible.next(false);
    }
}
